import { formatPlanPrice } from "../lib/planPricing";

export const paymentAmount = item =>
  typeof item.amount === "number" && Number.isFinite(item.amount) && item.amount >= 0 && /^[A-Z]{3}$/.test(item.currency || "")
    ? formatPlanPrice(item.amount, item.currency)
    : "Monto no disponible";

export const paymentDate = item => {
  const date = item.date ? new Date(item.date) : null;
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleDateString("es-CO", { day: "numeric", month: "short", year: "numeric", timeZone: "America/Bogota" })
    : "Fecha no disponible";
};

export default function PaymentHistory({ entries, error, onRetry, onDownload, downloading }) {
  return (
    <div className="payment-history">
      {error ? <div role="alert" className="payment-history-empty">
        <p>{error}</p><button type="button" onClick={onRetry}>Reintentar</button>
      </div> : entries.length === 0 ? <p className="payment-history-empty">No hay pagos confirmados</p> : <>
        <div className="payment-history-heading" aria-hidden="true">
          <span>Fecha</span><span>Descripción</span><span>Monto</span><span>Estado</span><span>Recibo</span>
        </div>
        <ul className="payment-history-list" aria-label="Pagos registrados">
          {entries.map((item, idx) => <li className="payment-history-row" key={item.id}>
            <div className="payment-history-date"><span className="payment-history-label">Fecha</span>{paymentDate(item)}</div>
            <div className="payment-history-description"><strong>{item.title}</strong><span>{item.desc}</span></div>
            <div className="payment-history-amount"><span className="payment-history-label">Monto</span><strong>{paymentAmount(item)}</strong></div>
            <div><span className={`payment-history-status ${item.status === "refunded" ? "is-refunded" : ""}`}>{item.status_label}</span></div>
            <div>{item.can_download && <button type="button" className="payment-history-download" disabled={downloading === idx}
              aria-label={`Descargar recibo de ${item.title} del ${paymentDate(item)}`} onClick={() => onDownload(idx)}>
              {downloading === idx ? "Generando…" : "Descargar"}
            </button>}</div>
          </li>)}
        </ul>
      </>}
      <style>{`
        .payment-history { width: 100%; min-width: 0; background: white; border-radius: 16px; overflow: hidden; color: #1b1f3a; }
        .payment-history-heading, .payment-history-row { display: grid; grid-template-columns: minmax(100px, 1fr) minmax(0, 2fr) minmax(130px, 1fr) minmax(100px, 1fr) minmax(85px, 1fr); gap: 16px; padding: 20px 24px; align-items: center; }
        .payment-history-heading { background: #f5f6fa; color: #6b7280; font-size: 12px; text-transform: uppercase; }
        .payment-history-list { list-style: none; padding: 0; margin: 0; }
        .payment-history-row { border-bottom: 1px solid #f3f4f6; font-size: 15px; line-height: 1.5; }
        .payment-history-row:last-child { border-bottom: none; }
        .payment-history-row > div { min-width: 0; overflow-wrap: anywhere; }
        .payment-history-description strong, .payment-history-description > span { display: block; }
        .payment-history-description > span { color: #6b7280; font-size: 14px; margin-top: 4px; }
        .payment-history-label { display: none; }
        .payment-history-status { display: inline-block; padding: 4px 10px; border-radius: 99px; background: #d1fae5; color: #065f46; font-size: 12px; font-weight: 700; }
        .payment-history-status.is-refunded { background: #fef3c7; color: #92400e; }
        .payment-history-download, .payment-history-empty button { color: #305dcc; background: transparent; border: none; cursor: pointer; padding: 10px 0; font: inherit; text-decoration: underline; }
        .payment-history-download:disabled { cursor: wait; opacity: .6; }
        .payment-history-empty { padding: 24px; color: #6b7280; }
        @media (max-width: 900px) {
          .payment-history-heading { display: none; }
          .payment-history-row { grid-template-columns: minmax(0, 1fr); gap: 12px; padding: 20px; align-items: start; }
          .payment-history-label { display: block; color: #6b7280; font-size: 12px; margin-bottom: 2px; }
          .payment-history-description { grid-row: 1; }
        }
      `}</style>
    </div>
  );
}
